export { BasketDrawerV2Connected } from './BasketDrawerV2Connected';
